/**
 *
 * CornerSelector
 *
 */
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectorRibbonOption from 'containers/Ribbon/CabinetRibbon/CornerSelector/CornerColor';
import inox from 'assets/images/corners/inox.png';
import galva from 'assets/images/corners/galva.png';
import black from 'assets/images/corners/black.png';
import white from 'assets/images/corners/white.png';
import { RootState } from 'containers/Ribbon/CabinetRibbon/types';
import { createStructuredSelector } from 'reselect';
import { Color } from 'lib/modelBuilder/entities/Color';
import {
  restoreCabinet,
  setCornersRequest,
} from 'containers/Configurator/actions/furniture';

import styled from 'styles/styled-components';
import {
  makeSelectLastHistoryCabinet,
  makeSelectLastHistoryCornersColor,
} from 'containers/Configurator/selectors/history';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { useTranslation } from 'react-i18next';
import {
  BLACK_COLOR,
  GALVA_COLOR,
  INOX_COLOR,
  WHITE_COLOR,
} from 'lib/modelBuilder/constants';

interface StateProps {
  cornersColor: Color | undefined;
  lastHistoryCabinet: Cabinet;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  cornersColor: makeSelectLastHistoryCornersColor(),
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
});

function CornerSelector() {
  const dispatch = useDispatch();
  const { cornersColor, lastHistoryCabinet } = useSelector(stateSelector);
  const { t } = useTranslation();

  function setCornerColor(reference: string, preview = false) {
    dispatch(setCornersRequest(reference, preview));
  }

  function onLeave() {
    // Restore the last history element
    dispatch(restoreCabinet(lastHistoryCabinet));
  }

  return (
    <SelectoOptionsArea
      // className="flex lg:bg-white lg:border-2 lg:border-grey-light mt-1 lg:-mt-1"
      onMouseLeave={onLeave}
    >
      <SelectorRibbonOption
        imageSrc={galva}
        title={t('Galva')}
        selected={cornersColor && cornersColor.reference === GALVA_COLOR}
        onClick={() => setCornerColor(GALVA_COLOR)}
        onHover={() => setCornerColor(GALVA_COLOR, true)}
        square
      />
      <SelectorRibbonOption
        imageSrc={inox}
        title={t('Inox')}
        selected={cornersColor && cornersColor.reference === INOX_COLOR}
        onClick={() => setCornerColor(INOX_COLOR)}
        onHover={() => setCornerColor(INOX_COLOR, true)}
        square
      />
      <SelectorRibbonOption
        imageSrc={black}
        title={t('Black')}
        selected={cornersColor && cornersColor.reference === BLACK_COLOR}
        onClick={() => setCornerColor(BLACK_COLOR)}
        onHover={() => setCornerColor(BLACK_COLOR, true)}
        square
      />
      <SelectorRibbonOption
        imageSrc={white}
        title={t('White')}
        selected={cornersColor && cornersColor.reference === WHITE_COLOR}
        onClick={() => setCornerColor(WHITE_COLOR)}
        onHover={() => setCornerColor(WHITE_COLOR, true)}
        square
      />
    </SelectoOptionsArea>
  );
}

export default CornerSelector;

export const SelectoOptionsArea = styled.div`
  //flex bg-white border-2 border-grey-light
  display: flex;

  //margin-top: 0.25rem;

  @media (max-width: 460px) {
    overflow-y: auto;
  }

  @media (min-width: 1024px) {
    //background-color: white;
    //border-width: 2px;
    border-color: #dae1e7;
  }
`;
